import React from "react";

import "./JakPrzebiegaW.css";

const AboutUs = () => (
    <div className="app__bg  section__padding" id="współpraca">
        <div className="zapoznaj">
        <hr className="hr3" />

            <h1 className="h1">Jak przebiega współpraca:</h1>
        </div>
        <div className="zapoznaj">
            <button className="btn">1</button>
            <p className="p-p">Zapoznaj się z ofertą.</p>
            <button className="btn">2</button>
            <p className="p-p">
                Wybierz pakiet, który najbardziej Ci odpowiada.
            </p>
            <button className="btn">3</button>
            <p className="p-p">
                Skontaktuj się ze mną{" "}
                <a
                    href="tel:+48 733824051"
                    // className="p__opensans"
                >
                    733 824 051{" "}
                </a>lub{" "}
                <a
                    href="mailto:Pk@przemyslawkokocinski.pl"
                    // className="p__opensans"
                >
                    Pk@przemyslawkokocinski.pl
                </a>
            </p>
            <button className="btn">4</button>
            <p className="p-p">Umów się na bezpłatną konsultację.</p>
            <button className="btn">5</button>
            <p className="p-p">
                Wypełnij i wyślij odpowiedni formularz – treningowy lub/i
                dietetyczny.
            </p>
            <button className="btn">6</button>
            <p className="p-p">Zacznij działać i realizować swój cel!</p>
        </div>
    </div>
);

export default AboutUs;
